import React from "react";
import AttendanceRecordsShared from "../attendance/AttendanceRecordsShared";

export default function CfmAttendanceRecords() {
  return <AttendanceRecordsShared backPath="/cfm/attendance" />;
}
